import { addNotification } from "../../../Utilities/notifications";
import axios from "../../../axios";
      
export const createSecret = async (payload) => {
  try {
    let {status}= await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/vault`, payload);     
    if(status === 200){
      addNotification({
        title: "Techforce.ai",
        message: "Secret Asset has been created successfully",
        type: "success"
      })
    }else if(status === 202){
      addNotification({
        title: "Techforce.ai",
        message: "Secret Already exists",
        type: "info"
      })
    }

    return status;
} catch (err) {
  console.log("Error while Creating Secret", err.message);
  addNotification({
    title: "Techforce.ai",
    message: "Secret Asset has been Failed ",
    type: "danger"
  });
}
}
    
  
